<template>
  <div class="search-input">
    <vs-input
      :placeholder="$t('search')"
      :value="value"
      @input="$emit('input', $event)"
      @keyup.enter="$emit('handleSearch')"
      class="w-full"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.search-input {
  margin-bottom: 1rem;
}
</style>
